import {
  CATEGORY,
  CATEGORIES,
  FILTERED,
  SUGGESTED_TOPICS,
} from 'hb-react/shared/apps/TopicsIndexV2/constants/types';

export default ({
  currentView,
  fetchCategoryTopics,
  fetchFilteredTopics,
  fetchMyTopics,
  fetchOtherTopics,
  setIsMember,
  topic,
}) => {
  if (topic.typeTopic === SUGGESTED_TOPICS) {
    // We update the 'joined_at' property in frontend side without fetching data.
    setIsMember(true);
  } else if (currentView === FILTERED) {
    fetchFilteredTopics();
  } else {
    if (currentView === CATEGORY || currentView === CATEGORIES) {
      if (topic.categories.length > 0) {
        topic.categories.forEach((category) => {
          fetchCategoryTopics(category.id);
        });
      } else {
        fetchOtherTopics();
      }
    }

    if (currentView === CATEGORIES) {
      fetchMyTopics();
    }
  }
};
